import { Link } from 'react-router-dom';

export default function Contact() {
  return (
    <div className="max-w-[820px] mx-auto px-4 md:px-8 pt-10 md:pt-16 pb-16">
      <div className="flex items-center gap-2 text-sm text-text-muted mb-4">
        <Link to="/" className="text-text-secondary hover:text-accent transition-colors">Home</Link>
        <span>/</span>
        <span>Contact</span>
      </div>

      <h1 className="font-display text-2xl md:text-[2.5rem] font-bold tracking-tight mb-6">Contact us</h1>

      <div className="article-body">
        <p>
          Whether you're a boatie with a question about the directory, a marine business wanting to list
          or update your details, or you've spotted something we should fix - we want to hear from you.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-4 mt-8">
        <div className="bg-card-light dark:bg-card border border-[rgba(16,42,66,0.09)] dark:border-[rgba(214,233,247,0.09)] rounded-xl p-6">
          <h2 className="font-display text-base font-bold mb-2">General enquiries</h2>
          <p className="text-sm text-text-secondary-light dark:text-text-secondary mb-3">
            Questions about the directory, listings, or anything MarineLink.
          </p>
          <a href="mailto:info@marinelink.co.nz" className="text-accent text-sm font-medium hover:underline">
            info@marinelink.co.nz
          </a>
        </div>

        <div className="bg-card-light dark:bg-card border border-[rgba(16,42,66,0.09)] dark:border-[rgba(214,233,247,0.09)] rounded-xl p-6">
          <h2 className="font-display text-base font-bold mb-2">List or update a business</h2>
          <p className="text-sm text-text-secondary-light dark:text-text-secondary mb-3">
            New listings, premium upgrades, or corrections to an existing listing.
          </p>
          <Link to="/list" className="text-accent text-sm font-medium hover:underline">
            Start a listing →
          </Link>
        </div>
      </div>

      <div className="bg-card-light dark:bg-card border border-[rgba(16,42,66,0.09)] dark:border-[rgba(214,233,247,0.09)] rounded-xl p-6 mt-4">
        <h2 className="font-display text-base font-bold mb-2">Where we are</h2>
        <p className="text-sm text-text-secondary-light dark:text-text-secondary">
          MarineLink Co NZ is based in Auckland, New Zealand - City of Sails, naturally.
          We cover the whole country, from the Far North to Southland.
        </p>
      </div>
    </div>
  );
}
